var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { RequestClient } from "../basics/request-client.service";
import { Api } from "../../constants/modules/api.constants";
import { toNative } from "../../utilities/promise-utils";
var RenderThemeClientService = /** @class */ (function () {
    function RenderThemeClientService(requestClient) {
        this.requestClient = requestClient;
    }
    RenderThemeClientService.prototype.getTheme = function (brandId, templateName, bundleId, syndicateId, brandLotteryId) {
        return toNative(this.requestClient.get(Api.RenderTheme.GetTheme, { brandId: brandId, templateName: templateName, bundleId: bundleId, syndicateId: syndicateId, brandLotteryId: brandLotteryId }, false, false));
    };
    RenderThemeClientService.prototype.getThemeById = function (renderThemeId) {
        return toNative(this.requestClient.get(Api.RenderTheme.GetThemeById + "/" + renderThemeId, {}, false, false));
    };
    RenderThemeClientService.prototype.saveTokens = function (request) {
        return toNative(this.requestClient.post(Api.RenderTheme.SaveTokens, {}, request));
    };
    RenderThemeClientService.prototype.saveLayout = function (request) {
        return toNative(this.requestClient.post(Api.RenderTheme.SaveLayout, {}, request));
    };
    RenderThemeClientService.prototype.publish = function (renderThemeId, bundleId, syndicateId, brandLotteryId) {
        return toNative(this.requestClient.post(Api.RenderTheme.Publish + "/" + renderThemeId, { bundleId: bundleId, syndicateId: syndicateId, brandLotteryId: brandLotteryId }, {}));
    };
    RenderThemeClientService.prototype.discardDraft = function (renderThemeId, bundleId, syndicateId, brandLotteryId) {
        return toNative(this.requestClient.post(Api.RenderTheme.DiscardDraft + "/" + renderThemeId, { bundleId: bundleId, syndicateId: syndicateId, brandLotteryId: brandLotteryId }, {}));
    };
    RenderThemeClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient])
    ], RenderThemeClientService);
    return RenderThemeClientService;
}());
export { RenderThemeClientService };
